export default __webpack_public_path__ + "static/media/loginLogo.8a47ad2e.svg";